import { $prose } from "@milkdown/utils"
import { Plugin, PluginKey } from "@milkdown/prose/state"

// Allows exiting marks with right arrow key
// When cursor is at end of marked text, pressing right clears stored marks
// so next typed character won't have the formatting
export const exitMarkPlugin = $prose(() => new Plugin({
	key: new PluginKey("exit-mark"),
	props: {
		handleKeyDown(view, event) {
			if (event.key !== "ArrowRight") return false

			const { state } = view
			const { selection, doc } = state
			if (!selection.empty) return false

			const pos = selection.$from
			const marks = pos.marks()
			if (marks.length === 0) return false

			// Check if we're at the end of the current text node or document
			const atEndOfNode = pos.pos === pos.end()
			const atEndOfDoc = pos.pos === doc.content.size - 1

			if (atEndOfNode || atEndOfDoc) {
				// Clear stored marks so next character is unformatted
				view.dispatch(state.tr.setStoredMarks([]))
				return false // Let default behavior still happen
			}
			return false
		},
	},
}))
